/// <reference path="../_references.ts"/>

module App.ItemManagement {
	import TitleBarService = App.Helpers.TitleBarService;
	import Appointment = App.Appointments.Appointment;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import ServicePlan = App.Appointments.ServicePlan;
	import ToastService = App.Utils.ToastService;
	import OfficeService = App.Utils.OfficeService;

	export class ItemManagementController {

		appointment: Appointment = null;
		servicePlan: ServicePlan = null;

		typeList: ServiceableItemType[] = null;
		showAddItem: boolean = false;
		isSaving: boolean = false;
		selectedItemType: ServiceableItemType = null;

		serviceableItemList: ServiceableItem[] = null;

		static $inject: string[] = ['$scope', '$state' ,'TitleBarService', 'ItemManagementService', 'SelectedAppointment', 'ModalService', 'ToastService', 'OfficeService'];

		constructor(
			private $scope: ng.IScope,
			private $state: ng.ui.IStateService,
			private TitleBarService: TitleBarService,
			private ItemManagementService: ItemManagementService,
			private SelectedAppointment: SelectedAppointment,
			private ModalService: any,
			private ToastService: ToastService,
			private OfficeService: OfficeService
		) {
			TitleBarService.set('Appointment');

			OfficeService.getAppointment().then(response => {
				this.setAppointment(response.data);
			})
			.catch(() => {
				SelectedAppointment.getAppointment().then((appointment) => {
					this.setAppointment(appointment);
				});
			});

			ItemManagementService.GetServiceableItemTypes().then((response) => {
				this.typeList = response.data;
			});
		}

		saveItem() {
			const vm = this,
				serviceableItem : ServiceableItemCreate = {
					address: vm.appointment.service_request.service_address.id,
					customer: vm.appointment.service_request.customer.id,
					created_service_request: vm.appointment.service_request.id,
					in_service: true,
					maintained: false,
					serviceable_item_type: vm.selectedItemType.id,
				};

			this.isSaving = true;

			 vm.ItemManagementService.CreateServiceableItem(serviceableItem)
				 .then((response) => {
					let item = response.data;

					vm.showAddItem = false;
					vm.selectedItemType = null;

					item.service_requests = item.service_requests || [];
					vm.serviceableItemList.unshift(item);
				 })
				 .finally(() => this.isSaving = false);
		}

		toggleAddItem() {
			const vm = this;

			if(vm.showAddItem) {
				vm.showAddItem = false;
				vm.selectedItemType = null;
			} else {
				vm.showAddItem = true;
			}
		}

		linkItemOpen(item: ServiceableItem) {
			const vm = this;

			var linkExists = !!item.service_requests.find((sr) => {
				return sr.id === vm.appointment.service_request.id;
			});

			var modalOptions = {
				templateUrl: "html/item-management/item-link.html",
				controller: function(close: (link: boolean) => void) {
					this.link = function(link: boolean) {
						close(link);
					};
					this.itemText = item.serviceable_item_type.name;
					this.linkExists = linkExists;
				 },
				controllerAs: 'ctrl',
				backdrop: 'static',
				keyboard: true
			};
			modalOptions.controller.$inject = ['close'];
			vm.ModalService.showModal(modalOptions).then((modal: any) => {
				modal.close.then((link: boolean) => {
					if(link && !linkExists) {
						vm.ItemManagementService.AddServiceRequest(item.id, vm.appointment.service_request.id).then((response) => {
							if(response.data.success) {
								vm.ToastService.show('Successfully added tag');
							}
							vm.itemDetails(item);
						});
					} else if(!link && linkExists) {
						vm.ItemManagementService.RemoveServiceRequest(item.id, vm.appointment.service_request.id).then((response) => {
							if(response.data.success) {
								vm.ToastService.show('Successfully removed tag');
							}
							vm.itemDetails(item);
						});
					} else {
						vm.itemDetails(item);
					}
				});
			});
		}

		itemDetails(item: ServiceableItem) {
			const vm = this;

			vm.$state.go('zipSolutions.maintenance.details', {
				itemId: item.id
			});
		}

		setAppointment(appointment: Appointment): void {
			const vm = this;

			vm.appointment = appointment;
			vm.servicePlan = vm.appointment.service_request.service_plan;

			vm.getServiceableItemList();
		}

		getServiceableItemList() {
			const vm = this;

			vm.ItemManagementService.GetServiceableItemListByCustomer(vm.appointment.service_request.customer.id, vm.appointment.service_request.service_address.id)
				.then((response) => {
					vm.serviceableItemList = response.data.map(function (item: any) {return new ServiceableItem(item);});
				});
		}

		isItemOnCurrentSR(item: ServiceableItem): boolean {
			return item.service_request && this.appointment && this.appointment.service_request &&
				item.service_request.id === this.appointment.service_request.id;
		}

		getItemColor(item: ServiceableItem): string {
			return item.maintained || this.isItemOnCurrentSR(item)
				? 'green'
				: 'red';
		}

		getMaintainedText(item: ServiceableItem) {
			return item.maintained
				? 'Active'
				: this.isItemOnCurrentSR(item)
					? 'Pending'
					: item.in_service
						? 'Inactive'
						: 'Out of Service';
		}

		displayServicePlan(servicePlan: ServicePlan): string {
			const vm = this;

			return servicePlan.name + ' - ' + (servicePlan.term === 'monthly' ? 'Monthly' : 'Annually');
		}

		displayDate(appointment: Appointment): string {
			return moment(appointment.scheduled_date + ' ' + appointment.scheduled_time, 'YYYY-MM-DD HH:mm').format('ddd, MMM Do YYYY hh:mma');
		}
	}
}